import { render } from "./MobileMarquee.vue?vue&type=template&id=a461817a&scoped=true&lang=pug"
import script from "./MobileMarquee.vue?vue&type=script&lang=js"
export * from "./MobileMarquee.vue?vue&type=script&lang=js"

import "./MobileMarquee.vue?vue&type=style&index=0&id=a461817a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a461817a"

export default script